var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "form-container"
  }, [_vm._m(0), _c('v-form', {
    model: {
      value: _vm.isValid,
      callback: function callback($$v) {
        _vm.isValid = $$v;
      },
      expression: "isValid"
    }
  }, [_c('vertical-form-table', _vm._b({
    model: {
      value: _vm.form,
      callback: function callback($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }, 'vertical-form-table', {
    items: _vm.items
  }, false)), _c('div', {
    staticClass: "pb-0 mt-16 mt-md-24 mt-lg-32"
  }, [_c('terms-of-agreements-short', {
    on: {
      "isValid": function (_isValid) {
        function isValid(_x) {
          return _isValid.apply(this, arguments);
        }

        isValid.toString = function () {
          return _isValid.toString();
        };

        return isValid;
      }(function (isValid) {
        return _vm.isTermsValid = isValid;
      })
    },
    model: {
      value: _vm.form._terms,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "_terms", $$v);
      },
      expression: "form._terms"
    }
  })], 1), _c('div', {
    staticClass: "mt-30 mt-md-44 mt-lg-60"
  }, [_c('v-row', {
    staticClass: "row row--small",
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "w-100 min-w-sm-160px",
    attrs: {
      "large": "",
      "color": "grey lighten-3",
      "outlined": ""
    }
  }, [_c('span', {
    staticClass: "grey--text"
  }, [_vm._v("취소")])])], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "auto"
    }
  }, [_c('v-btn', _vm._b({
    staticClass: "w-100 min-w-sm-160px",
    attrs: {
      "large": "",
      "color": "secondary"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('save');
      }
    }
  }, 'v-btn', {
    disabled: _vm.disabled
  }, false), [_c('span', {
    staticClass: "white--text"
  }, [_vm._v("작성완료")])])], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page-text page-text--xs grey--text text-right pb-16 pb-md-20"
  }, [_c('span', {
    staticClass: "secondary--text"
  }, [_vm._v("*")]), _vm._v(" 필수입력 항목입니다.")]);
}]

export { render, staticRenderFns }